import { GrnItems } from "../grn-items.entity";
import { Grn } from "../grn.entity";
import { GrnDto } from "./grn.dto";

export class GrnAdapter {
    convertDtoToEntity(dtoObj: GrnDto, isUpdate: boolean = false,count,vendorPriceStatus:boolean,vendorItemMap,grnNumber:string,tdsFlag:boolean,prevAmount : number): Grn {
        try {
            console.log(dtoObj)
            let totQty = 0; 
            let totDoscount = 0; 
            let totTaxAmount = 0; 
            let totCost = 0; 

            const entityObj = new Grn();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.grnDate = dtoObj.grnDate;
            entityObj.poId = dtoObj.poId;
            entityObj.unitId = dtoObj.unitId;
            entityObj.remarks = dtoObj.remarks;
            entityObj.approvar = dtoObj.approvar;
            entityObj.referenceNumber = count;
            entityObj.grnNumber = grnNumber;
            entityObj.status = dtoObj.status;
            entityObj.InvoiceDate = dtoObj.InvoiceDate;
            entityObj.vendorId = dtoObj.vendorId;
            entityObj.invoiceNumber = dtoObj.invoiceNumber;
            const genItems: GrnItems[] = [];
            for (const grnItem of dtoObj.grnItemsInfo) {
                let itemAmount = (Number(grnItem.receivedQuantity) * Number(grnItem.unitPrice)) - Number(grnItem.discountAmount)
                if(grnItem.acceptedQuantity>0){
                    let taxableAmount
                    if(tdsFlag){
                        taxableAmount = Number(itemAmount)
                    }else{
                        if(Number(prevAmount) + Number(itemAmount) > 5000000){
                        taxableAmount = (Number(prevAmount) + Number(itemAmount)) - 5000000
                        tdsFlag = true
                        }else{
                        tdsFlag = false
                        taxableAmount = 0
                        }
                        prevAmount = Number(prevAmount) + Number(itemAmount)
                    }

                    const grnIemsObject: GrnItems = new GrnItems();
                    // grnIemsObject.saleOrderId = entityObj.saleOrderId;
                    totQty += Number(grnItem.acceptedQuantity);
                    totDoscount += Number(grnItem.discountAmount);
                    totTaxAmount += Number(grnItem.taxAmount);
                    totCost += Number(grnItem.totalAmount);


    
                    grnIemsObject.grnId = grnItem.grnId;
                    grnIemsObject.poId = dtoObj.poId;
                    grnIemsObject.itemCategoryId = grnItem.itemCategoryId;
                    grnIemsObject.itemSubCategoryId = grnItem.itemSubCategoryId;
                    grnIemsObject.itemId = grnItem.itemId;
                    grnIemsObject.sizeId = grnItem.sizeId?grnItem.sizeId:0;
                    grnIemsObject.poQuantity = grnItem.poQuantity;
                    grnIemsObject.acceptedQuantity = grnItem.acceptedQuantity;
                    grnIemsObject.rejectedQuantity = grnItem.rejectedQuantity;
                    grnIemsObject.receivedQuantity = grnItem.receivedQuantity;
                    grnIemsObject.unitPrice = grnItem.unitPrice;
                    grnIemsObject.tdsApplicable = tdsFlag
                    grnIemsObject.taxableAmount = taxableAmount
                    if(vendorPriceStatus){
                        const vendorActualPrice = vendorItemMap.get(dtoObj.vendorId).get(grnItem.itemId)
                        grnIemsObject.actualPrice = vendorActualPrice;
                    }else{
                        grnIemsObject.actualPrice = grnItem.unitPrice;
                    }
                    grnIemsObject.discountPercentage = grnItem.discountPercentage;
                    grnIemsObject.discountAmount = grnItem.discountAmount;
                    grnIemsObject.taxPercentage = grnItem.taxPercentage;
                    //need to remove if else condition if soId saved as '0' 
                    if(grnItem.saleOrderId > 0){
                        grnIemsObject.saleOrderId = grnItem.saleOrderId;
                    }else{
                        grnIemsObject.saleOrderId = 0;
                    }
                    grnIemsObject.taxAmount = grnItem.taxAmount;
                    grnIemsObject.totalAmount = grnItem.totalAmount;
                    grnIemsObject.createdUser = grnItem.createdUser;
                    // grnIemsObject.versionFlag = grnItem.versionFlag;
                    genItems.push(grnIemsObject);
                }

            }
            console.log(totQty);

            entityObj.totalQuantity = totQty;
            entityObj.totalDiscount = totDoscount;
            entityObj.totalTax = totTaxAmount;
            entityObj.totalCost = totCost;

          
            if (dtoObj.grnId) {
                entityObj.grnId = dtoObj.grnId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }

            entityObj.grnItemsInfo = genItems;
            return entityObj;
            // return entityObj;
        } catch (error) {
            return error;
        }
    }

    public convertEntityToDto(grnObj: Grn): GrnDto {
        const grnDto = new GrnDto;
      
        grnDto.grnId = grnObj.grnId;
        grnDto.unitId = grnObj.unitId;
        grnDto.grnNumber = grnObj.grnNumber;
        grnDto.status = grnObj.status;
        grnDto.grnDate = grnObj.grnDate;
        grnDto.invoiceNumber = grnObj.invoiceNumber;
        grnDto.InvoiceDate = grnObj.InvoiceDate;
        grnDto.totalCost = grnObj.totalCost;
        grnDto.approvar = grnObj.approvar;
        grnDto.createdAt = grnObj.createdAt;
        grnDto.updatedAt = grnObj.updatedAt;
        grnDto.createdUser = grnObj.createdUser;
        grnDto.updatedUser = grnObj.updatedUser;
        // grnDto.versionFlag = grnObj.versionFlag;
        grnDto.grnItemsInfo = grnObj.grnItemsInfo;
        grnDto.poId = grnObj.poId;
        
        return grnDto;
    }
}